<template>
  <div class="as-employee-new-page">
    <AsEmployeePage :tableHeaders="headers" />
  </div>
</template>

<script>
import AsEmployeePage from "@components/AsEmployeePage/AsEmployeePage.vue";

export default {
  name: "AsEmployeeNewPage",
  components: {
    AsEmployeePage,
  },
  data() {
    return {
      headers: [
        {
          text: "Responsibility Assignments",
          sortable: false,
          value: "responsibilityAssign",
          width: "50%",
        },
        {
          text: "Badge",
          sortable: false,
          value: "badge",
          width: "13%",
        },
        {
          text: "Inspection Status",
          sortable: false,
          value: "inspectionStatus",
          width: "17%",
        },
        {
          text: "Available Inspectors",
          sortable: false,
          value: "available",
          width: "12%",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
          width: "8%",
        },
      ],
    };
  },
};
</script>

<style scoped>
.as-employee-new-page {
  padding: 20px;
  width: 100%;
}
.as-employee-page {
  width: 98%;
}
</style>
